import { css } from "@emotion/react";
import { MEDIA_QUERY_FOR_PC } from "constants/mediaQueryForPc";
import { MEDIA_QUERY_FOR_SP } from "constants/mediaQueryForSp";

export const actionButtonStyle = css`
  ${MEDIA_QUERY_FOR_PC} {
    width: 328px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
  }
`;

export const skeletonButtonStyle = css`
  height: 32px;
  border-radius: 6px;
  border: 1px solid #000;
  background: linear-gradient(90deg, #fff 25%, #ddd 50%, #fff 75%);
  background-size: 200% 100%;
  animation: loading 1.5s infinite;
  pointer-events: none;

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  ${MEDIA_QUERY_FOR_PC} {
    width: 328px;
  }

  ${MEDIA_QUERY_FOR_SP} {
    width: 100%;
  }
`;
